module.exports = require("././ui-map.js");


//////////////////
// WEBPACK FOOTER
// angular-ui-map (bower component)
// module id = 1453
// module chunks = 0